import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {bonusAccrualClassificationByBrand_template} from "./bonusAccrualClassificationByBrand_template";

declare var ko: any;

export class bonusAccrualByBrand_template extends vnTemplate{

    protected validationsList: validationsList_template;
    protected yearFilter: filterDropdown_template;
    protected brandFilter: filterDropdown_template;
    protected freelancerBonusAccrualTemplate: bonusAccrualClassificationByBrand_template;
    protected employeeBonusAccrualTemplate: bonusAccrualClassificationByBrand_template;


    protected getTemplateHtml(): string{

        return `

           <div class="sub-header">
                <div class="w-justify">
                    <div class="w-left">
                        <div><label class="form-label form-label-box">Year</label> ${ this.yearFilter.getHtmlBuild() }</div>
                        <div><label class="form-label form-label-box" >Brand</label>${ this.brandFilter.getHtmlBuild() }</div>

                    </div>
                </div>
                <div class="w-justify">
                    <div class="w-filters-selected">
                        <div id="filters-selected" class="filters-selected">
                           <div id="selected-accounts"></div>
                           <div id="selected-companies"></div>
                        </div>
                    </div>
                </div>
            </div>
            
            ${  this.validationsList.getHtmlBuild() }

            <div class="w-form w-form-large" id="data-list-result">
            
                <div class="form-header">
                    <h3 class="form-title icon i-star-full">Bonus Accrual by Brand</h3> 
                    <button class="close-button icon i-close-2" type="button" data-bind="event: { click: onClickCancel }"></button>
                </div>
             
                <div class="w-form-body">
                    ${ this.freelancerBonusAccrualTemplate.getHtmlBuild() }
                    ${ this.employeeBonusAccrualTemplate.getHtmlBuild() }
                </div>
                
                <div class="form-footer">
                    <button data-bind="event: { click: onClickCancel }" class="btn" type="button">Cancel</button>
                    <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button> 
                </div>
            </div> 
            `;
    }

    protected initPartial(): void {

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
        this.yearFilter = new filterDropdown_template("yearFilter", this.getTemplateViewModel(), this.caller);
        this.brandFilter = new filterDropdown_template( "brandFilter", this.getTemplateViewModel(), this.caller );
        this.freelancerBonusAccrualTemplate = new bonusAccrualClassificationByBrand_template('freelancerBonusAccrualTemplate', this.getTemplateViewModel(), this.caller);
        this.freelancerBonusAccrualTemplate.setClassification('Freelancers');
        this.freelancerBonusAccrualTemplate.setTotalEditorialClassificationBonusTitle('P&L TOTAL EDITORIAL FREELANCE BONUS');
        this.freelancerBonusAccrualTemplate.setParent(this);
        this.employeeBonusAccrualTemplate = new bonusAccrualClassificationByBrand_template('employeeBonusAccrualTemplate', this.getTemplateViewModel(), this.caller);
        this.employeeBonusAccrualTemplate.setClassification('Employees');
        this.employeeBonusAccrualTemplate.setTotalEditorialClassificationBonusTitle('P&L TOTAL EDITORIAL EMPLOYEE BONUS');
        this.employeeBonusAccrualTemplate.setParent(this);
    }

    protected getTemplateName(): string{
        return "bonusAccrualByBrand-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-content"];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let self = this;
        return  {
            currentMonth: ko.observable(new Date().getMonth()+1),
            projectedCost: ko.observableArray([]),
            scheduledAndPaidCost: ko.observableArray([]),
            totalPerMonth: ko.observableArray([]),
            onClickSave:function (data, event) { self.onClickSave(); },
            onClickCancel:function (data, event) { self.onClickCancel(); }
        };
    }

    public getViewModelForRequest() {

        return {
            filters: {
                idBrand: this.getTemplateViewModel().brandFilter.selectedOption,
                yearFilter: this.getTemplateViewModel().yearFilter.selectedOption
            }
        }
    }

    public getMonths(){
        return [
            { id : 1, name : 'January', percentage : 0, amount : ko.observable(0), enable: true },
            { id : 2, name : 'February', percentage : 0, amount : ko.observable(0), enable: true },
            { id : 3, name : 'March', percentage : 0, amount : ko.observable(0), enable: true },
            { id : 4, name : 'April', percentage : 0, amount : ko.observable(0), enable: true },
            { id : 5, name : 'May', percentage : 0, amount : ko.observable(0), enable: true },
            { id : 6, name : 'June', percentage : 0, amount : ko.observable(0), enable: false },
            { id : 7, name : 'July', percentage : 0, amount : ko.observable(0), enable: true },
            { id : 8, name : 'August', percentage : 0, amount : ko.observable(0), enable: true },
            { id : 9, name : 'September', percentage : 0, amount : ko.observable(0), enable: true },
            { id : 10, name : 'October', percentage : 0, amount : ko.observable(0), enable: true },
            { id : 11, name : 'November', percentage : 0, amount : ko.observable(0), enable: true },
            { id : 12, name : 'December', percentage : 0, amount : ko.observable(0), enable: false },
        ];
    }

    public getPostRequestData() {

        return  {

            idBrand: this.getSelectedBrand(),
            yearFilter: this.getSelectedYear(),
            freelancers: this.freelancerBonusAccrualTemplate.getPostRequestData(),
            employees: this.employeeBonusAccrualTemplate.getPostRequestData(),
        };
    }


    public setFreelancersResult(data): void {

        this.freelancerBonusAccrualTemplate.setProjectedCost(data.projectedCost);
        this.freelancerBonusAccrualTemplate.setScheduledAndPaidCost(data.scheduledAndPaidCost);
        this.freelancerBonusAccrualTemplate.updateList(data.exitingBonusAccruals);
    }

    public setEmployeesResult(data): void {

        this.employeeBonusAccrualTemplate.setProjectedCost(data.projectedCost);
        this.employeeBonusAccrualTemplate.setScheduledAndPaidCost(data.scheduledAndPaidCost);
        this.employeeBonusAccrualTemplate.updateList(data.exitingBonusAccruals);
    }

    public setMonths(months){

        this.freelancerBonusAccrualTemplate.setMonths(months);
        this.employeeBonusAccrualTemplate.setMonths(months);
    }

    public getSelectedYear() {
        return this.yearFilter.getTemplateViewModel().selectedOption();
    }

    public getSelectedBrand() {
        return this.brandFilter.getTemplateViewModel().selectedOption();
    }

    public onClickSave(){

        this.caller.save();
    }

    public onClickCancel(){

        this.caller.cancel();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/bonusAccrualByBrand_template.ts